import * as Sentry from '@sentry/browser';

export default [ '$provide', ($provide) => {
  let errorDelegation = ($delegate) => {
    /* global SENTRY_DSN */
    let sentryDsn = SENTRY_DSN;

    if (sentryDsn) {
      try{
        Sentry.init({ dsn: sentryDsn });
      }catch(error) {
        sentryDsn = undefined;
      }
    }

    return function(exception, cause) {
      if (sentryDsn) {
        Sentry.captureException(exception, { cause:cause });
      }
      $delegate(exception, cause);
    }
  }
  $provide.decorator('$exceptionHandler', [
    '$delegate',
    errorDelegation
  ]);
} ]



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/error/configs/exceptionHandler.config.js